<template>
  <div style="height: 100%">
    <!-- 页面骨架:筛选区(商品名/供货商/状态) + ve-table列表(含主图缩略图) + 新增编辑弹窗 -->
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.amgName" style="width: 160px" size="mini" placeholder="商品名称"
            clearable></el-input>
          <el-select size="mini" v-model="formDatas.amsId" filterable clearable placeholder="供货商"
            style="width: 160px;" @change="partserch">
            <el-option v-for="item in supplierList" :key="item.amsId"
              :label="item.amsName + (item.amsStatus === 2 ? '(已禁用)' : '')" :value="item.amsId"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.amgStatus" clearable placeholder="状态"
            style="width: 120px;" @change="partserch">
            <el-option label="待上架" :value="1" key="g1"></el-option>
            <el-option label="上架" :value="2" key="g2"></el-option>
            <el-option label="下架" :value="3" key="g3"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAdd">新增商品</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="amgId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 新增/编辑商品弹窗 -->
    <el-dialog :title="edit ? '编辑商品' : '新增商品'" :visible.sync="dialog" width="640px"
      :close-on-click-modal="false" @closed="handleDialogClosed">
      <el-form ref="formRef" :model="form" label-width="90px" :rules="rules">
        <el-form-item label="商品名称" prop="amgName">
          <el-input v-model.trim="form.amgName" maxlength="200" show-word-limit placeholder="请输入商品名称(200字内)"></el-input>
        </el-form-item>
        <el-form-item label="供货商" prop="amsId">
          <!-- 编辑时不允许改供货商(后端编辑接口不收归属字段),仅新增可选;禁用供货商置灰 -->
          <el-select v-model="form.amsId" filterable placeholder="请选择供货商" style="width: 100%"
            :disabled="edit">
            <el-option v-for="item in supplierList" :key="item.amsId"
              :label="item.amsName + (item.amsStatus === 2 ? '(已禁用)' : '')" :value="item.amsId"
              :disabled="item.amsStatus === 2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售价" prop="amgPrice">
          <!-- 售价只能取分账档位四档,直接存分值(12000/24000/36000/48000),非档位后端拒绝(卖出后无法分账) -->
          <el-radio-group v-model="form.amgPrice">
            <el-radio-button v-for="item in priceOptions" :key="item" :label="item">{{ item / 100 }}元档
            </el-radio-button>
          </el-radio-group>
          <!-- 历史非档位价回显时radio无选中项,给出提示引导重选 -->
          <div v-if="priceMismatch" style="width: 100%; color: #F56C6C; font-size: 12px; line-height: 1.6">
            当前售价 {{ priceMismatchYuan }}元 为历史非档位价格，保存前必须重新选择档位
          </div>
        </el-form-item>
        <el-form-item label="移动编码" prop="amgMobileSku">
          <!-- 权益金扣减时传移动侧specsSku的口径字段,上架前必填(上架时后端强校验) -->
          <el-input v-model.trim="form.amgMobileSku" maxlength="100" show-word-limit
            placeholder="移动商品编码(specsSku口径,选填,上架前必填)"></el-input>
          <div style="color: #909399; font-size: 12px; line-height: 1.6">
            移动编码/名称从移动侧获取，为权益金扣减传参口径；商品上架前必填
          </div>
        </el-form-item>
        <el-form-item label="移动名称" prop="amgMobileName">
          <!-- 权益金扣减时传移动侧specsName的口径字段,上架前必填(上架时后端强校验) -->
          <el-input v-model.trim="form.amgMobileName" maxlength="200" show-word-limit
            placeholder="移动商品名称(specsName口径,选填,上架前必填)"></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="amgStock">
          <el-input-number v-model="form.amgStock" :min="0" :max="999999" :step="1" step-strictly
            controls-position="right" style="width: 200px"></el-input-number>
        </el-form-item>
        <el-form-item label="商品主图" prop="amgImage">
          <!-- 主图:拖拽上传(限1张),成功后接口返回的COS完整URL写入form.amgImage -->
          <el-upload class="mall-upload" :class="{ 'mall-upload--hide': mainFileList.length >= 1 }" drag action="#"
            list-type="picture-card" accept="image/jpeg,image/png,image/webp" :limit="1" :file-list="mainFileList"
            :before-upload="beforeImageUpload" :http-request="doUploadImage" :on-change="handleMainChange"
            :on-success="handleMainSuccess" :on-error="handleUploadError" :on-exceed="handleMainExceed">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
            <div class="mall-upload__tip" slot="tip">jpg / png / webp，单张不超过 5MB，最多 1 张</div>
            <!-- 自定义卡片:上传中loading遮罩,成功后hover删除 -->
            <div slot="file" slot-scope="{ file }" class="mall-upload__item">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <div v-if="file.status !== 'success'" class="mall-upload__loading">
                <i class="el-icon-loading"></i>
              </div>
              <span v-else class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="removeMainImage(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="详情轮播图">
          <!-- 轮播图:拖拽多选上传(限9张,卡片顺序=提交顺序),提交时url数组join(',')写入amgImages -->
          <el-upload class="mall-upload" drag action="#" list-type="picture-card" accept="image/jpeg,image/png,image/webp"
            :limit="9" multiple :file-list="bannerFileList" :before-upload="beforeImageUpload"
            :http-request="doUploadImage" :on-change="handleBannerChange" :on-success="handleBannerSuccess"
            :on-error="handleUploadError" :on-exceed="handleBannerExceed">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
            <div class="mall-upload__tip" slot="tip">
              jpg / png / webp，单张不超过 5MB，最多 9 张；hover 卡片可左移/右移调序、删除
            </div>
            <div slot="file" slot-scope="{ file }" class="mall-upload__item">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <div v-if="file.status !== 'success'" class="mall-upload__loading">
                <i class="el-icon-loading"></i>
              </div>
              <span v-else class="el-upload-list__item-actions">
                <span v-if="bannerFileList[0] !== file" class="el-upload-list__item-delete"
                  @click="moveBannerImage(file, -1)"><i class="el-icon-back"></i></span>
                <span v-if="bannerFileList[bannerFileList.length - 1] !== file"
                  class="el-upload-list__item-delete" @click="moveBannerImage(file, 1)">
                  <i class="el-icon-right"></i></span>
                <span class="el-upload-list__item-delete" @click="removeBannerImage(file)">
                  <i class="el-icon-delete"></i></span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" prop="amgSort">
          <el-input-number v-model="form.amgSort" :min="0" :max="9999" :step="1" step-strictly
            controls-position="right" style="width: 200px"></el-input-number>
          <span style="margin-left: 10px; color: #909399; font-size: 12px">数值小的排在前面</span>
        </el-form-item>
        <el-form-item label="图文详情" prop="amgDetail">
          <!-- 富文本编辑器(wangeditor):支持图文混排;图片经后端转存COS后以URL插入;
               内容实时同步 form.amgDetail 随表单提交,小程序详情页 mp-html 渲染 -->
          <div ref="detailEditor" class="detail-editor"></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" :disabled="hasUploading" @click="sureBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import wangEditor from "wangeditor";
import {
  getAjefMallSupplierList,
  getAjefMallGoodsList,
  addAjefMallGoods,
  updateAjefMallGoods,
  updateAjefMallGoodsStatus,
  uploadFileToTxCloudEquityFee,
} from "../../api/api";

// 售价档位固定四档(存分值):与后端分账规则表口径一致(120/240/360/480元),非档位商品卖出后无法分账
const PRICE_OPTIONS = [12000, 24000, 36000, 48000];
// 图片上传限制:仅jpg/png/webp,单张最大5MB(张数上限由模板limit控制:主图1张/轮播图9张)
const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
const IMAGE_MAX_SIZE = 5 * 1024 * 1024;

export default {
  name: "MallGoods",
  components: {},
  data() {
    return {
      tableLoading: false,
      submitLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      formDatas: {
        amgName: "",
        amsId: "",
        amgStatus: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 供货商下拉数据(含状态,用于禁用标识与上架按钮判断)
      supplierList: [],
      // 售价档位选项(挂实例供模板v-for,分值口径)
      priceOptions: PRICE_OPTIONS,
      // 新增/编辑弹窗
      dialog: false,
      edit: false,
      // 主图上传列表(受控模式,on-change同步;limit=1)
      mainFileList: [],
      // 轮播图上传列表(顺序即提交顺序,提交时join逗号串)
      bannerFileList: [],
      form: {
        amgId: null,
        amsId: "",
        amgName: "",
        amgPrice: "",
        amgMobileSku: "",
        amgMobileName: "",
        amgStock: 0,
        amgImage: "",
        amgDetail: "",
        amgSort: 0,
      },
      rules: {
        amgName: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        amsId: [{ required: true, message: "请选择供货商", trigger: "change" }],
        amgPrice: [{ required: true, message: "请选择售价档位", trigger: "change" }],
        amgStock: [{ required: true, message: "请填写库存", trigger: "change" }],
        // 主图必填:值由上传成功回调写入,无值时validate拦截
        amgImage: [{ required: true, message: "请上传商品主图", trigger: "change" }],
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "amgImage",
          key: "amgImage",
          title: "主图",
          width: 80,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            if (!row.amgImage) {
              return "-";
            }
            // 缩略图,点击可预览大图
            return h("el-image", {
              props: {
                src: row.amgImage,
                previewSrcList: [row.amgImage],
                fit: "cover",
              },
              style: { width: "40px", height: "40px", display: "inline-block", borderRadius: "4px" },
            });
          },
        },
        {
          field: "amgName",
          key: "amgName",
          title: "商品名称",
          width: 200,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row }) => row.amgName || "-",
        },
        {
          field: "amsName",
          key: "amsName",
          title: "供货商",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) => row.amsName || "-",
        },
        {
          field: "amgPrice",
          key: "amgPrice",
          title: "售价档位",
          width: 100,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 档位内:tag徽标(120元档等);非档位历史价:红tag提示无法分账,须编辑重选
            if (PRICE_OPTIONS.indexOf(row.amgPrice) !== -1) {
              return h("el-tag", { props: { size: "mini" } }, row.amgPrice / 100 + "元档");
            }
            const priceText = row.amgPriceStr != null && row.amgPriceStr !== ""
              ? row.amgPriceStr
              : row.amgPrice != null ? this.fenToYuan(row.amgPrice) : "-";
            return h("el-tooltip", { props: { content: "历史非档位价格,卖出无法分账,请编辑重选档位", placement: "top" } }, [
              h("el-tag", { props: { type: "danger", size: "mini" } }, priceText + "元(非档位)"),
            ]);
          },
        },
        {
          field: "amgMobileSku",
          key: "amgMobileSku",
          title: "移动编码",
          width: 150,
          align: "center",
          // 超长省略(悬浮看全称);为空时红字提示未配置,上架前必须补齐
          ellipsis: { showTitle: true },
          renderBodyCell: ({ row }, h) => {
            if (row.amgMobileSku) {
              return row.amgMobileSku;
            }
            return h("span", { style: { color: "#F56C6C", fontSize: "12px" } }, "未配置");
          },
        },
        {
          field: "amgStock",
          key: "amgStock",
          title: "库存",
          width: 80,
          align: "center",
        },
        {
          field: "amgStatus",
          key: "amgStatus",
          title: "状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 1待上架 2上架 3下架
            const statusMap = {
              1: { text: "待上架", type: "info" },
              2: { text: "上架", type: "success" },
              3: { text: "下架", type: "danger" },
            };
            const status = statusMap[row.amgStatus];
            if (status) {
              return h("el-tag", { props: { type: status.type, size: "mini" } },
                row.amgStatusDes || status.text);
            }
            return "-";
          },
        },
        {
          field: "amgSort",
          key: "amgSort",
          title: "排序",
          width: 70,
          align: "center",
        },
        { field: "createtime", key: "createtime", title: "创建时间", width: 170, align: "center" },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 170,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            const buttons = [];
            // 上架按钮:仅待上架/下架可点,且供货商须正常(供货商禁用不可上架)
            if (row.amgStatus === 1 || row.amgStatus === 3) {
              const supplierDisabled = this.isSupplierDisabled(row.amsId);
              buttons.push(h("el-tooltip", {
                props: {
                  content: supplierDisabled ? "供货商已禁用,不可上架" : "上架后小程序端可见可购买",
                  placement: "top",
                  disabled: !supplierDisabled,
                },
              }, [
                h("el-button", {
                  props: { type: "text", size: "mini", disabled: supplierDisabled },
                  style: { color: supplierDisabled ? "#C0C4CC" : "#67C23A", padding: "0", marginRight: "10px" },
                  on: { click: () => this.handleStatus(row, 2) },
                }, "上架"),
              ]));
            }
            // 下架按钮:仅上架状态可点
            if (row.amgStatus === 2) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#F56C6C", padding: "0", marginRight: "10px" },
                on: { click: () => this.handleStatus(row, 3) },
              }, "下架"));
            }
            buttons.push(h("el-button", {
              props: { type: "text", size: "mini" },
              style: { color: "#409EFF", padding: "0" },
              on: { click: () => this.openEdit(row) },
            }, "编辑"));
            return h("div", buttons);
          },
        },
      ],
    };
  },
  computed: {
    // 编辑回显的历史售价不在四档内时提示重选(radio无匹配项不会选中)
    priceMismatch() {
      return this.form.amgPrice !== "" && this.form.amgPrice != null && PRICE_OPTIONS.indexOf(this.form.amgPrice) === -1;
    },
    priceMismatchYuan() {
      return this.fenToYuan(this.form.amgPrice);
    },
    // 是否有图片正在上传中(提交按钮禁用依据)
    hasUploading() {
      const all = this.mainFileList.concat(this.bannerFileList);
      return all.some((item) => item.status === "ready" || item.status === "uploading");
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
    this.getList();
    this.getSupplierList();
  },
  methods: {
    // 分转元展示:整数除法+取余,避免浮点误差
    fenToYuan(fen) {
      const yuan = Math.floor(fen / 100);
      const cent = Math.abs(fen % 100);
      return yuan + "." + String(cent).padStart(2, "0");
    },
    // 供货商下拉数据(大页拉全量,含amsStatus用于置灰与上架判断)
    getSupplierList() {
      getAjefMallSupplierList({ currentPage: 1, pageSize: 9999 }).then((res) => {
        if (!res) {
          return;
        }
        this.supplierList = res.data || [];
      });
    },
    // 该商品供货商是否禁用(下拉数据查不到时按未禁用处理,由后端上架校验兜底)
    isSupplierDisabled(amsId) {
      if (amsId == null) {
        return false;
      }
      const supplier = this.supplierList.find((item) => item.amsId === amsId);
      return !!supplier && supplier.amsStatus === 2;
    },
    getList() {
      this.tableLoading = true;
      getAjefMallGoodsList(this.formDatas).then((res) => {
        this.tableLoading = false;
        if (!res) {
          return;
        }
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 打开新增弹窗
    openAdd() {
      this.edit = false;
      this.dialog = true;
      // 富文本编辑器在弹窗渲染后初始化(新增传空内容)
      this.$nextTick(() => {
        this.initDetailEditor("");
      });
    },
    // 打开编辑弹窗(深拷贝;售价按分值直接回显匹配档位,图片URL串构造fileList回显缩略图)
    openEdit(row) {
      this.edit = true;
      this.dialog = true;
      this.$nextTick(() => {
        this.form = {
          amgId: row.amgId,
          amsId: row.amsId,
          amgName: row.amgName,
          amgPrice: row.amgPrice != null ? row.amgPrice : "",
          amgMobileSku: row.amgMobileSku || "",
          amgMobileName: row.amgMobileName || "",
          amgStock: row.amgStock,
          amgImage: row.amgImage || "",
          amgDetail: row.amgDetail,
          amgSort: row.amgSort,
        };
        // 富文本回显:历史纯文本(\n换行)转<br/>兼容,富文本HTML原样
        this.initDetailEditor(this.richDetailFromLegacy(row.amgDetail));
        // 主图回显:单张URL构造成功态卡片
        this.mainFileList = row.amgImage
          ? [{ name: "主图", url: row.amgImage, status: "success" }]
          : [];
        // 轮播回显:历史串兼容逗号/中文逗号/换行分隔(旧textarea录入格式),拆成卡片列表
        this.bannerFileList = (row.amgImages || "")
          .split(/[\n,，]/)
          .map((item) => item.trim())
          .filter((item) => item)
          .map((url, index) => ({ name: "轮播图" + (index + 1), url: url, status: "success" }));
      });
    },
    handleDialogClosed() {
      this.$refs.formRef.resetFields();
      this.form = {
        amgId: null,
        amsId: "",
        amgName: "",
        amgPrice: "",
        amgMobileSku: "",
        amgMobileName: "",
        amgStock: 0,
        amgImage: "",
        amgDetail: "",
        amgSort: 0,
      };
      // 销毁富文本实例(清内容+解绑事件),下次打开弹窗重新 create,避免内容残留
      if (this.detailEditor) {
        this.detailEditor.destroy();
        this.detailEditor = null;
      }
      // 清空上传列表,避免下次打开残留上次文件(也会中断进行中上传的内部回调)
      this.mainFileList = [];
      this.bannerFileList = [];
      // 修复OBS-11:提交请求挂起时关弹窗,submitLoading残留会让重开后的确定按钮永久禁用
      this.submitLoading = false;
    },
    // ===== 图文详情富文本编辑器(wangeditor v4) =====
    // 初始化(幂等):实例挂 this.detailEditor(非响应式);内容 onchange 实时同步 form.amgDetail
    initDetailEditor(html) {
      if (!this.$refs.detailEditor) {
        return;
      }
      if (!this.detailEditor) {
        const editor = new wangEditor(this.$refs.detailEditor);
        editor.config.height = 260;
        editor.config.placeholder = "支持图文混排，图片自动上传后插入（小程序详情页展示，选填）";
        // 图片走 customUpload:复用商品主图同一条后端转存COS通道,存完整HTTPS URL(禁用网络图片直链,保证小程序端可加载)
        editor.config.showLinkImg = false;
        editor.config.customUploadImg = (files, insert) => {
          this.uploadDetailImages(files, insert);
        };
        // 内容变化实时回写表单(选填字段,提交时再做空壳清洗)
        editor.config.onchange = (html) => {
          this.form.amgDetail = html;
        };
        editor.create();
        this.detailEditor = editor;
      }
      this.detailEditor.txt.html(html || "");
    },
    // 富文本图片上传:类型/大小校验与主图同一套口径,单张独立上传互不阻塞
    uploadDetailImages(files, insert) {
      files.forEach((file) => {
        const isImage =
          IMAGE_TYPES.indexOf(file.type) !== -1 || /\.(jpe?g|png|webp)$/i.test(file.name || "");
        if (!isImage) {
          this.$message.error("图片仅支持 jpg / png / webp 格式");
          return;
        }
        if (file.size > IMAGE_MAX_SIZE) {
          this.$message.error("图片大小不能超过 5MB");
          return;
        }
        const formData = new FormData();
        formData.append("file", file);
        uploadFileToTxCloudEquityFee(formData).then((res) => {
          if (res && res.status === 200 && res.data) {
            insert(res.data); // 后端返回完整HTTPS URL,插入编辑器
          } else {
            this.$message.error("图片上传失败");
          }
        }).catch(() => {
          this.$message.error("图片上传失败");
        });
      });
    },
    // 历史数据兼容:旧textarea录入的纯文本(\n换行)转<br/>供编辑器回显;富文本HTML原样
    richDetailFromLegacy(content) {
      const text = String(content || "");
      if (!text) return "";
      if (/<(p|br|img|div|span|section|h[1-6]|ul|ol|li|table)[\s>/]/i.test(text)) return text;
      return text.replace(/\r\n|\r|\n/g, "<br/>");
    },
    // 富文本空壳清洗:无文字且无图片时视为未填,存空串(避免存<p><br></p>类空壳HTML)
    normalizeDetailForSubmit() {
      const detail = this.form.amgDetail || "";
      const hasText = detail.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, " ").trim() !== "";
      const hasImg = detail.indexOf("<img") !== -1;
      this.form.amgDetail = hasText || hasImg ? detail : "";
    },
    // ===== 图片拖拽上传(主图/轮播图共用一套通道) =====
    // 上传前校验:accept只拦文件选择器,拖拽进来由这里兜底;类型jpg/png/webp,单张不超过5MB
    beforeImageUpload(file) {
      const isImage =
        IMAGE_TYPES.indexOf(file.type) !== -1 || /\.(jpe?g|png|webp)$/i.test(file.name || "");
      if (!isImage) {
        this.$message.error("图片仅支持 jpg / png / webp 格式");
        this.dropRejectedFile(file.uid); // 修复P2:返回false不发请求但el-upload会留ready僵尸卡,主动剔除防提交按钮永久禁用
        return false;
      }
      if (file.size > IMAGE_MAX_SIZE) {
        this.$message.error("图片大小不能超过 5MB");
        this.dropRejectedFile(file.uid);
        return false;
      }
      return true;
    },
    // 剔除被校验拒绝的文件:before-upload返回false仅拦截请求,列表项会以ready态残留(永久loading/不可删/hasUploading恒真),受控列表同步移除让视图立即消失
    dropRejectedFile(uid) {
      this.mainFileList = this.mainFileList.filter((item) => item.uid !== uid);
      this.bannerFileList = this.bannerFileList.filter((item) => item.uid !== uid);
    },
    // 自定义上传:FormData字段file直传后端,后端转存腾讯云COS并返回完整HTTPS URL
    // 注意:request拦截器在业务错误时返回undefined,必须判空reject,否则el-upload会误判为成功
    doUploadImage(options) {
      options.onProgress({ percent: 0 }); // 置为uploading态,卡片显示loading遮罩
      const formData = new FormData();
      formData.append("file", options.file);
      return uploadFileToTxCloudEquityFee(formData).then((res) => {
        if (!res || res.status !== 200 || !res.data) {
          return Promise.reject(new Error("图片上传失败"));
        }
        return res;
      });
    },
    // 上传失败:拦截器已弹具体错误通知,这里统一提示;失败卡片已在on-change里丢弃
    handleUploadError() {
      if (!this.dialog) {
        return;
      }
      this.$message.error("图片上传失败，请重新上传");
    },
    // 主图:on-change同步列表(受控;fail项即时丢弃避免留破图卡片)
    handleMainChange(file, fileList) {
      if (!this.dialog) {
        return;
      }
      this.mainFileList = fileList.filter((item) => item.status !== "fail");
    },
    // 主图上传成功:返回的完整URL写入amgImage(缩略图同步从本地blob切换为远端URL)
    handleMainSuccess(res, file) {
      if (!this.dialog) {
        return;
      }
      file.url = res.data;
      this.form.amgImage = res.data;
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField("amgImage");
      }
    },
    // 主图删除:清空amgImage并移除卡片
    removeMainImage(file) {
      this.mainFileList = this.mainFileList.filter((item) => item.uid !== file.uid);
      this.form.amgImage = "";
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField("amgImage");
      }
    },
    handleMainExceed() {
      this.$message.warning("主图最多上传 1 张，请先删除已有图片");
    },
    // 轮播图:on-change同步列表(卡片顺序=拖入/上传顺序)
    handleBannerChange(file, fileList) {
      if (!this.dialog) {
        return;
      }
      this.bannerFileList = fileList.filter((item) => item.status !== "fail");
    },
    // 轮播图上传成功:仅替换卡片缩略图;amgImages在提交时由列表join得出
    handleBannerSuccess(res, file) {
      if (!this.dialog) {
        return;
      }
      file.url = res.data;
    },
    // 轮播图删除:移除卡片(提交值随列表重算)
    removeBannerImage(file) {
      this.bannerFileList = this.bannerFileList.filter((item) => item.uid !== file.uid);
    },
    handleBannerExceed() {
      this.$message.warning("轮播图最多上传 9 张");
    },
    // 轮播图调序:相邻位置简单swap(不引排序库)
    moveBannerImage(file, offset) {
      const list = this.bannerFileList;
      const index = list.findIndex((item) => item.uid === file.uid);
      const target = index + offset;
      if (index === -1 || target < 0 || target >= list.length) {
        return;
      }
      const arr = list.slice();
      const tmp = arr[target];
      arr[target] = arr[index];
      arr[index] = tmp;
      this.bannerFileList = arr;
    },
    // 提交新增/编辑
    sureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return;
        }
        // 图片仍在传输中时兜底拦截(按钮已禁用,防时序漏网)
        if (this.hasUploading) {
          this.$message.warning("图片正在上传中，请稍候");
          return;
        }
        // 修复OBS-03：编辑回显的历史非档位售价不可直接提交，
        // 强校验必须在四档分值内(12000/24000/36000/48000)，否则阻断(后端同样会拒绝)
        if (PRICE_OPTIONS.indexOf(this.form.amgPrice) === -1) {
          this.$message.warning("售价必须为 120/240/360/480 元档位");
          return;
        }
        // 提交参数:售价为档位分值直传;移动编码/名称按权益金扣减口径传后端(trim后空串不传);
        // 轮播图按列表顺序取成功项URL,join逗号串(后端存储口径);富文本空壳清洗后提交
        this.normalizeDetailForSubmit();
        const data = {
          amgName: this.form.amgName,
          amgPrice: this.form.amgPrice,
          amgMobileSku: this.form.amgMobileSku || null,
          amgMobileName: this.form.amgMobileName || null,
          amgStock: this.form.amgStock,
          amgImage: this.form.amgImage,
          amgImages: this.bannerFileList
            .filter((item) => item.status === "success" && item.url)
            .map((item) => item.url)
            .join(","),
          amgDetail: this.form.amgDetail,
          amgSort: this.form.amgSort,
        };
        this.submitLoading = true;
        const req = this.edit
          ? updateAjefMallGoods(Object.assign({}, data, { amgId: this.form.amgId }))
          : addAjefMallGoods(Object.assign({}, data, { amsId: this.form.amsId }));
        req.then((res) => {
          this.submitLoading = false;
          if (!res) {
            return;
          }
          this.$message.success(this.edit ? "修改成功" : "新增成功(新建商品为待上架状态)");
          this.dialog = false;
          this.getList();
        }).catch(() => {
          this.submitLoading = false;
        });
      });
    },
    // 上架/下架状态机操作
    handleStatus(row, amgStatus) {
      if (amgStatus === 2) {
        // 上架前置校验(与后端口径一致):移动编码/名称缺失时拦截,引导先编辑补齐
        if (!row.amgMobileSku || !row.amgMobileName) {
          this.$message.warning("请先编辑商品补齐移动商品编码和移动商品名称，再上架");
          return;
        }
        this.$confirm(
          "上架后小程序端可见并可购买(供货商需为正常状态)。确定上架该商品？",
          "上架商品",
          { type: "warning", confirmButtonText: "确定上架", cancelButtonText: "取消" }
        ).then(() => {
          this.doStatus(row, amgStatus);
        }).catch(() => { });
      } else {
        this.$confirm(
          "下架后小程序端立即不可见不可购买,已下单订单不受影响。确定下架该商品？",
          "下架商品",
          { type: "warning", confirmButtonText: "确定下架", cancelButtonText: "取消" }
        ).then(() => {
          this.doStatus(row, amgStatus);
        }).catch(() => { });
      }
    },
    doStatus(row, amgStatus) {
      updateAjefMallGoodsStatus({ amgId: row.amgId, amgStatus: amgStatus }).then((res) => {
        if (!res) {
          return;
        }
        this.$message.success(amgStatus === 2 ? "已上架" : "已下架");
        this.getList();
      });
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.ve-table-container {
  height: auto !important;
}

/* 图文详情富文本编辑器:边框/圆角与 Element 表单控件一致;弹层(z-index)高于 el-dialog 保证下拉面板可点 */
.detail-editor {
  width: 100%;
  line-height: normal;
}

.detail-editor .w-e-toolbar {
  background-color: #f5f7fa !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px 4px 0 0 !important;
}

.detail-editor .w-e-text-container {
  border: 1px solid #dcdfe6 !important;
  border-top: none !important;
  border-radius: 0 0 4px 4px !important;
  background-color: #ffffff;
}

.detail-editor .w-e-panel-container,
.detail-editor .w-e-drop-panel,
.detail-editor .w-e-select-list {
  z-index: 2100 !important; /* el-dialog 默认 z-index 约 2000+,编辑器内面板需更高才不被遮挡 */
}

.detail-editor .w-e-text-container [data-slate-editor] p,
.detail-editor .w-e-text-container .w-e-text-placeholder {
  line-height: 1.6;
}
</style>

<style scoped>
/* 商品图片拖拽上传区:横向长条(覆盖picture-card默认148方块与dragger默认360x180) */
.mall-upload /deep/ .el-upload--picture-card {
  width: 100%;
  height: 104px;
  line-height: 1;
  border: none; /* 虚线框交给内层dragger,保留拖入高亮反馈 */
  background: transparent;
}

.mall-upload /deep/ .el-upload-dragger {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mall-upload /deep/ .el-upload-dragger:hover {
  border-color: #409eff;
}

.mall-upload /deep/ .el-upload-dragger .el-icon-upload {
  font-size: 36px;
  margin: 0 0 6px;
  line-height: 1;
}

.mall-upload__tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 2px;
}

/* 主图已上传1张后隐藏拖拽区,只留卡片 */
.mall-upload--hide /deep/ .el-upload--picture-card {
  display: none;
}

/* 自定义卡片内容铺满148px卡片 */
.mall-upload__item {
  width: 100%;
  height: 100%;
}

/* 卡片上传中遮罩 */
.mall-upload__loading {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  color: #909399;
  font-size: 24px;
  z-index: 1;
}
</style>
